import angular from 'angular';
import AlertsWidgetComponent from './alerts-widget-component';
import AlertComponent from './alert/alert-component';

export default angular
  .module('alerts-widget', [])
  .component('alert', new AlertComponent())
  .component('alertsWidget', new AlertsWidgetComponent());



// WEBPACK FOOTER //
// ./src/modules/dashboard/components/dashboard-widget/alerts/alerts-widget-module.js